import store from "../../../../../../store";
import {setMultiLoader} from "../../../../../../actions/actionFunctions";

/**
 * Chat gpt v4
 */

class SingleModelGLBViewer {
  spinner = null;
  animationFrameId = null;
  lightIntensity = 800;
  envMap = null;
  gltf = null;
  isMobile = false;

  constructor(canvas, glbUrl, lightIntensity, isMobile) {
    //glbUrl = "https://qc-3dfiles.s3.amazonaws.com/ar-composer/W3030.glb"
    //glbUrl = "/images/sqft-icons/3d/Chair.glb"
    //glbUrl = "/images/sqft-icons/3d/DCW2430 Summer Flame.glb"
    //glbUrl = "/images/sqft-icons/3d/hood/Hood Oven GLB/Appliances/Hood_0_0_0_30_0_0_Collection/All-Hood ZLINE 8654SNZ CB-30-25.6.glb"
    //glbUrl = "https://discoverthreejs.com/examples/assets/models/Parrot.glb"
    //glbUrl = "https://threejs.org/examples/models/gltf/AnisotropyBarnLamp.glb"
    this.canvas = canvas;
    this.glbUrl = glbUrl;
    this.lightIntensity = lightIntensity;
    this.isMobile = isMobile;
    //this.mouseDown = false;

    // this.initSpinner();
    //this.initScene();
    this.initSceneV2();
    //this.loadEXRAndModel();
    this.loadGLBModel();
    //this.addEventListeners();
  }

  initSceneV2() {
    this.scene = new window.THREE.Scene();
    //this.scene.background = new window.THREE.Color(0xf0f0f0);
    //this.scene.background = new window.THREE.Color(0xbcc4ce);
    this.scene.background = new window.THREE.Color(0xcccccc);

    this.camera = new window.THREE.PerspectiveCamera(45, this.canvas.clientWidth / this.canvas.clientHeight, 0.1, 1000);
    this.camera.position.set(0, 0, 5);

    this.renderer = new window.THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, preserveDrawingBuffer: true });
    //this.renderer.setPixelRatio(this.isMobile ? window.devicePixelRatio * 0.5 : window.devicePixelRatio);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight, false);

    this.renderer.outputColorSpace = window.THREE.SRGBColorSpace;
    this.renderer.useLegacyLights = false;
    this.renderer.toneMapping = window.THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 0.1;
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = true;
    this.renderer.shadowMap.type = window.THREE.VSMShadowMap;
    this.renderer.gammaOutput = true;
    this.renderer.gammaFactor = 2.2;

    this.controls = new window.OrbitControls(this.camera, this.renderer.domElement);
    this.controls.target.set(0, 0, 0);
    this.controls.update();
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.1;
    this.controls.screenSpacePanning = true;
    this.controls.minDistance = 0.1;
    this.controls.maxDistance = 100;

    //const hdrBackgroundPath = "/images/sqft-icons/3d/comfy_cafe_1k.hdr"
    //this.loadHDRAsBackground(hdrBackgroundPath);
    //this.addLightV3();
    //this.addLightV4();
    //this.addLightV2();
    //this.addLightGrey();
    this.animate();
  }

  // initSpinner() {
  //   this.spinner = document.createElement('div');
  //   this.spinner.style.position = 'absolute';
  //   this.spinner.style.top = '50%';
  //   this.spinner.style.left = '50%';
  //   this.spinner.style.transform = 'translate(-50%, -50%)';
  //   this.canvas.parentElement.appendChild(this.spinner);
  //   ReactDOM.render(<CircularProgress />, this.spinner);
  // }

  loadEXRAndModel() {
    const loader = new window.EXRLoader();
    const pmremGenerator = new window.PMREMGenerator(this.renderer);
    pmremGenerator.compileEquirectangularShader();

    loader.load('/images/sqft-icons/3d/gray.exr', (texture) => {
      const exrCubeRenderTarget = pmremGenerator.fromEquirectangular(texture);
      this.envMap = exrCubeRenderTarget.texture;

      texture.dispose();
      pmremGenerator.dispose();

      // Теперь загружаем модель
      this.loadGLBModel();
    }, undefined, (error) => {
      console.error('Error loading .exr file', error);
      this.loadGLBModel();
    });
  }

  loadGLBModel() {
    const loader = new window.GLTFLoader();
    loader.load(
      this.glbUrl,
      (gltf) => {
        this.gltf = gltf;
        const box = new window.THREE.Box3().setFromObject(gltf.scene);
        const size = box.getSize(new window.THREE.Vector3()).length();
        const center = box.getCenter(new window.THREE.Vector3());

        this.halfHeight = size / 2;
        //this.addFloor();
        //this.addFloorV2();

        if (this.controls) {
          this.controls.reset();
          this.controls.maxDistance = size * 10;
        }

        if (this.camera) {
          this.camera.position.copy(center);
          this.camera.position.x += size; // far distance
          this.camera.position.y += size / 5.0;
          //this.camera.position.z += size;
          this.camera.position.z *= -1; // rotate distance

          this.camera.near = size / 100;
          this.camera.far = size * 100;
          this.camera.updateProjectionMatrix();
        }

        gltf.scene.position.x += -center.x;
        gltf.scene.position.y += -center.y;// + size / 2;
        gltf.scene.position.z += -center.z;

        gltf = this.correctGltfProps(gltf);
        //this.addLightV4(gltf);
        //this.addLightV5(gltf);
        if (this.scene) {
          this.addLightV8(gltf);
        }
        //this.addLightV6(gltf);

        if (this.envMap) {
          gltf.scene.traverse((child) => {
            if (child.isMesh) {
              child.material.envMap = this.envMap;
              child.material.envMapIntensity = 0.5;
              child.material.needsUpdate = true;
            }
          });
        }
        this.scene.add(gltf.scene);
        console.log("gltf.cameras[0];", gltf.cameras[0]);
        this.renderer.shadowMap.needsUpdate = true;

        //hide loader
        // this.spinner.style.display = 'none';
        store.dispatch(setMultiLoader({activeStep: 8})); // first remove animation
        setTimeout(() => {
          store.dispatch(setMultiLoader({visible: false}));
        }, 500)
      },
      undefined,
      (error) => console.error(error)
    );
  }

  correctGltfProps(gltf) {
    gltf.scene.children.forEach(element => {
      // console.log(element);
      if (element.isMesh) {
        element.children.forEach(child => {
          child.receiveShadow = true;
        });
        element.castShadow = true;
        element.receiveShadow = true;
        element.visible = false;
      }
      if (element.isGroup) {
        element.children.forEach(e => {
          void e;
          if (element.isMesh) {
            element.castShadow = true;
            element.receiveShadow = true;
          }
          if (element.isLight) {
            element.visible = false;
          }
        })
      }
      if (element.isLight) {
        element.intensity *= 0.05;
        console.log(element);
        element.visible = false;
      }
    });

    return gltf
  }

  addLightV4(gltf) {
    const box = new window.THREE.Box3().setFromObject(gltf.scene);
    const boxSize = box.getSize(new window.THREE.Vector3());
    const boxCenter = box.getCenter(new window.THREE.Vector3());
    boxSize.multiplyScalar(10.1);
    for (let x = boxCenter.x - boxSize.x / 2; x <= boxCenter.x + boxSize.x / 2; x += boxSize.x / 2) {
      for (let z = boxCenter.z - boxSize.z / 2; z <= boxCenter.z + boxSize.z / 2; z += boxSize.z) {
        let light = new window.THREE.PointLight(0xffffff,  this.lightIntensity, 0, 2);
        light.position.set(x, 1.1, z);
        light.castShadow = true;
        this.scene.add(light);

        light = new window.THREE.PointLight(0xffffff,  this.lightIntensity, 0, 2);
        light.position.set(x, 4.0, z);
        light.castShadow = true;
        this.scene.add(light);
      }
    }
  }

  addLightV5(gltf) {
    const box = new window.THREE.Box3().setFromObject(gltf.scene);
    const boxSize = box.getSize(new window.THREE.Vector3());
    const boxCenter = box.getCenter(new window.THREE.Vector3());

    const maxSize = Math.max(boxSize.x, boxSize.y, boxSize.z);
    // Расчет отдаленности источников света и их высоты
    const lightOffset = maxSize * 2;
    const baseHeight = maxSize * 0.25 * 2; // Базовая высота для источников света

    // Увеличиваем интенсивность света более существенно для больших моделей
    // Используем квадратный корень от lightOffset для более мягкого масштабирования
    //const intensityScale = Math.sqrt(lightOffset / 2);
    const intensityScale = Math.exp(lightOffset);
    const dynamicIntensity = this.lightIntensity + intensityScale;

    console.log(`maxSize: ${maxSize}, lightOffset: ${lightOffset}, baseHeight: ${baseHeight}`);
    console.log(`intensityScale: ${intensityScale}`);
    console.log(`this.lightIntensity: ${this.lightIntensity }`);
    console.log(`dynamicIntensity: ${dynamicIntensity}`);

    const lightPositions = [
      // Central light
      { x: 0, y: baseHeight, z: lightOffset },

      // Upper light
      { x: lightOffset, y: baseHeight, z: lightOffset },
      { x: -lightOffset, y: baseHeight, z: lightOffset },
      { x: lightOffset, y: baseHeight, z: -lightOffset },
      { x: -lightOffset, y: baseHeight, z: -lightOffset },

      // Bottom Light
      { x: lightOffset, y: -baseHeight, z: lightOffset },
      { x: -lightOffset, y: -baseHeight, z: lightOffset },
      { x: lightOffset, y: -baseHeight, z: -lightOffset },
      { x: -lightOffset, y: -baseHeight, z: -lightOffset }
    ];

    lightPositions.forEach(pos => {
      let light = new window.THREE.PointLight(0xffffff, dynamicIntensity, 0, 2);
      light.position.set(boxCenter.x + pos.x, boxCenter.y + pos.y, boxCenter.z + pos.z);
      light.castShadow = true;
      this.scene.add(light);
      console.log(`Light position: x: ${pos.x}, y: ${pos.y}, z: ${pos.z}, Intensity: ${dynamicIntensity}`);
    });

    // Добавление окружающего света для общего освещения
    const ambientLight = new window.THREE.AmbientLight(0xffffff, 0.2);
    this.scene.add(ambientLight);

    //console.log("dynamicIntensity", dynamicIntensity);
  }

  addLightV6(gltf) {
    const box = new window.THREE.Box3().setFromObject(gltf.scene);
    const boxSize = box.getSize(new window.THREE.Vector3());
    const boxCenter = box.getCenter(new window.THREE.Vector3());

    // Расчет оптимального расстояния и интенсивности света исходя из размера модели
    const maxDimension = Math.max(boxSize.x, boxSize.y, boxSize.z);
    const lightDistance = maxDimension * 0.5; // Расстояние света от центра модели
    const lightIntensity = 1.0; // Базовая интенсивность света, может быть скорректирована

    // Позиционирование света вокруг объекта
    for (let x = boxCenter.x - maxDimension / 2; x <= boxCenter.x + maxDimension / 2; x += maxDimension / 2) {
      for (let z = boxCenter.z - maxDimension / 2; z <= boxCenter.z + maxDimension / 2; z += maxDimension) {
        // Верхний свет
        let light = new window.THREE.PointLight(0xffffff, lightIntensity, lightDistance, 2);
        light.position.set(x, boxCenter.y + maxDimension / 2, z); // Позиционирование света над моделью
        light.castShadow = true;
        this.scene.add(light);

        // Нижний свет, опущен ниже относительно модели
        light = new window.THREE.PointLight(0xffffff, lightIntensity, lightDistance, 2);
        light.position.set(x, boxCenter.y - maxDimension / 3, z); // Позиционирование света под моделью
        light.castShadow = true;
        this.scene.add(light);
      }
    }
  }

  addLightV7(gltf) {
    const box = new window.THREE.Box3().setFromObject(gltf.scene);
    const boxSize = box.getSize(new window.THREE.Vector3());
    const boxCenter = box.getCenter(new window.THREE.Vector3());

    // Вычисляем коэффициенты для адаптации расстояния источников света к размерам модели
    const maxDimension = Math.max(boxSize.x, boxSize.y, boxSize.z);
    const lightDistance = maxDimension * 1.5; // Устанавливаем расстояние источников света, исходя из максимального размера
    const verticalOffset = maxDimension * 0.5; // Вертикальное смещение света для поддержки различной высоты моделей

    // Создаем источники света
    const lights = [];
    for (let i = 0; i < 8; i++) {
      lights.push(new window.THREE.PointLight(0xffffff, this.lightIntensity));
    }

    // Располагаем источники света вокруг модели, учитывая ее размеры и пропорции
    lights[0].position.set(boxCenter.x + lightDistance, boxCenter.y + verticalOffset, boxCenter.z + lightDistance);
    lights[1].position.set(boxCenter.x + lightDistance, boxCenter.y - verticalOffset, boxCenter.z + lightDistance);

    lights[2].position.set(boxCenter.x + lightDistance, boxCenter.y + verticalOffset, boxCenter.z - lightDistance);
    lights[3].position.set(boxCenter.x + lightDistance, boxCenter.y - verticalOffset, boxCenter.z - lightDistance);

    lights[4].position.set(boxCenter.x - lightDistance, boxCenter.y + verticalOffset, boxCenter.z - lightDistance);
    lights[5].position.set(boxCenter.x - lightDistance, boxCenter.y - verticalOffset, boxCenter.z - lightDistance);

    lights[6].position.set(boxCenter.x - lightDistance, boxCenter.y + verticalOffset, boxCenter.z + lightDistance);
    lights[7].position.set(boxCenter.x - lightDistance, boxCenter.y - verticalOffset, boxCenter.z + lightDistance);

    // Добавляем источники света в сцену
    lights.forEach(light => this.scene.add(light));
  }

  addLightV8(gltf) {
    const box = new window.THREE.Box3().setFromObject(gltf.scene);
    const boxSize = box.getSize(new window.THREE.Vector3());
    const boxCenter = box.getCenter(new window.THREE.Vector3());
    console.log("boxCenter", boxCenter);

    const maxSize = Math.max(boxSize.x, boxSize.y, boxSize.z);
    const lightOffset = 5;
    const baseHeight = 3;

    const dynamicIntensity = this.lightIntensity ;

    console.log(`maxSize: ${maxSize}, lightOffset: ${lightOffset}, baseHeight: ${baseHeight}`);
    console.log(`this.lightIntensity: ${this.lightIntensity }`);
    console.log(`dynamicIntensity: ${dynamicIntensity}`);

    const lightPositions = [
      // Central light
      { x: 0, y: baseHeight / 2, z: 5 },
      { x: 0, y: baseHeight * 2, z: 5 },

      // Upper corner Light
      { x: lightOffset, y: baseHeight, z: lightOffset },
      { x: -lightOffset, y: baseHeight, z: lightOffset },
      { x: lightOffset, y: baseHeight, z: -lightOffset },
      { x: -lightOffset, y: baseHeight, z: -lightOffset },

      // Bottom light
      { x: lightOffset, y: -baseHeight, z: lightOffset },
      { x: -lightOffset, y: -baseHeight, z: lightOffset },
      { x: lightOffset, y: -baseHeight, z: -lightOffset },
      { x: -lightOffset, y: -baseHeight, z: -lightOffset }
    ];


    lightPositions.forEach(pos => {
      let light = new window.THREE.PointLight(0xffffff, dynamicIntensity, 0, 2);
      light.position.set(boxCenter.x + pos.x, boxCenter.y + pos.y, boxCenter.z + pos.z);
      light.castShadow = true;
      this.scene.add(light);
      //console.log(`Light position: x: ${pos.x}, y: ${pos.y}, z: ${pos.z}, Intensity: ${dynamicIntensity}`);
    });

    // Добавление окружающего света для общего освещения
    const ambientLight = new window.THREE.AmbientLight(0xffffff, 0.2);
    this.scene.add(ambientLight);

    const directionalLight = new window.THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(boxCenter.x, boxCenter.y, boxCenter.z +10);
    directionalLight.castShadow = true;
    this.scene.add(directionalLight);
  }

  updateSceneLighting(type) {
    // Удаление текущего освещения
    this.scene.children = this.scene.children.filter(child => !(child instanceof window.THREE.Light));

    // Добавление нового освещения
    switch (type) {
      case 'addLightV4':
        this.addLightV4(this.gltf);
        break;
      case 'addLightV5':
        this.addLightV5(this.gltf);
        break;
      case 'addLightV6':
        this.addLightV6(this.gltf);
        break;
      case 'addLightV7':
        this.addLightV7(this.gltf);
        break;
      case 'addLightV8':
        this.addLightV8(this.gltf);
        break;
      // Добавьте кейсы для новых методов освещения здесь
      default:
        console.warn(`Unknown lighting type: ${type}`);
        break;
    }
  }

  addLightGrey() {
    const ambientLight = new window.THREE.AmbientLight(0x736e6e, 10);
    this.scene.add(ambientLight);

    const directionalLight = new window.THREE.DirectionalLight(0x736e6e, 8);
    directionalLight.position.set(0, 10, 10);
    directionalLight.castShadow = true;
    this.scene.add(directionalLight);

    //
    // light in front
    //
    let pointLight = new window.THREE.PointLight(0x736e6e, 8);
    pointLight.position.set(1.6, 1, 0);
    pointLight.castShadow = true;
    this.scene.add(pointLight);

    pointLight = new window.THREE.PointLight(0x736e6e, 8);
    pointLight.position.set(-2, 1, 0);
    pointLight.castShadow = true;
    this.scene.add(pointLight);

    pointLight = new window.THREE.PointLight(0x736e6e, 8);
    pointLight.position.set(0, 1, 0);
    pointLight.castShadow = true;
    this.scene.add(pointLight);

    //
    // light behind
    //
    // pointLight = new window.THREE.PointLight(0xffffff, 8);
    // pointLight.position.set(1.6, 1, -5);
    // pointLight.castShadow = true;
    // this.scene.add(pointLight);
    //
    // pointLight = new window.THREE.PointLight(0xffffff, 8);
    // pointLight.position.set(-2, 1, -5);
    // pointLight.castShadow = true;
    // this.scene.add(pointLight);
    //
    // pointLight = new window.THREE.PointLight(0xffffff, 8);
    // pointLight.position.set(0, 1, -5);
    // pointLight.castShadow = true;
    // this.scene.add(pointLight);
  }

  addWhiteLight() {
    const ambientLight = new window.THREE.AmbientLight(0xffffff, 0.6);
    this.scene.add(ambientLight);

    const directionalLight = new window.THREE.DirectionalLight(0xffffff, 0.8);
    //directionalLight.position.set(1, 2, 4);
    directionalLight.position.set(0, 10, 10);
    directionalLight.castShadow = true;
    this.scene.add(directionalLight);
  }

  addFloor() {
    const floorGeometry = new window.THREE.PlaneGeometry(100, 100);
    //const floorMaterial = new window.THREE.MeshStandardMaterial({ color: 0x9A9A9A });
    const floorMaterial = new window.THREE.MeshStandardMaterial({ color: 0x000000});
    const floor = new window.THREE.Mesh(floorGeometry, floorMaterial);
    floor.rotation.x = -Math.PI / 2;
    floor.position.y = -this.halfHeight;
    floor.receiveShadow = true;
    this.scene.add(floor);
  }

  addFloorV2() {
    const floorMat = new window.THREE.MeshStandardMaterial({
      roughness: 0.8,
      color: 0xffffff,
      metalness: 0.2,
      bumpScale: 1
    });

    const textureLoader = new window.THREE.TextureLoader();

    // Load and set diffuse texture
    textureLoader.load('/images/sqft-icons/3d/textures/hardwood2_diffuse.jpg', function(map) {
      map.wrapS = window.THREE.RepeatWrapping;
      map.wrapT = window.THREE.RepeatWrapping;
      map.anisotropy = 4;
      map.repeat.set(10, 24);
      map.encoding = window.THREE.sRGBEncoding; // Updated to use .encoding instead of .colorSpace
      floorMat.map = map;
      floorMat.needsUpdate = true;
    });

    // Load and set bump map
    textureLoader.load('/images/sqft-icons/3d/textures/hardwood2_bump.jpg', function(map) {
      map.wrapS = window.THREE.RepeatWrapping;
      map.wrapT = window.THREE.RepeatWrapping;
      map.anisotropy = 4;
      map.repeat.set(10, 24);
      floorMat.bumpMap = map;
      floorMat.needsUpdate = true;
    });

    // Load and set roughness map
    textureLoader.load('/images/sqft-icons/3d/textures/hardwood2_roughness.jpg', function(map) {
      map.wrapS = window.THREE.RepeatWrapping;
      map.wrapT = window.THREE.RepeatWrapping;
      map.anisotropy = 4;
      map.repeat.set(10, 24);
      floorMat.roughnessMap = map;
      floorMat.needsUpdate = true;
    });

    const floorGeometry = new window.THREE.PlaneGeometry(20, 20);
    const floorMesh = new window.THREE.Mesh(floorGeometry, floorMat);
    floorMesh.receiveShadow = true;
    floorMesh.position.y = -1.2;
    floorMesh.rotation.x = -Math.PI / 2.0;
    this.scene.add(floorMesh);
  }

  updateLightIntensity(intensity) {
    this.lightIntensity = intensity
    this.scene.children.forEach(child => {
      if (child instanceof window.THREE.PointLight) {
        //console.log("child.intensity", child.intensity);
        child.intensity = intensity;
      }
    });
  }

  animate() {
    this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
    this.controls.update();
    this.renderer.render(this.scene, this.camera);
  }

  stop() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

  dispose() {
    // Stop the animation loop
    this.stop();

    // Dispose of all resources
    //this.scene.dispose(); //todo
    this.renderer.dispose();
    this.controls.dispose();

    // Remove spinner
    // if (this.spinner) {
    //   ReactDOM.unmountComponentAtNode(this.spinner);
    //   this.spinner.remove();
    //   this.spinner = null;
    // }

    // Nullify properties to free up memory
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.controls = null;
    this.canvas = null;
  }

  onMouseDown() {
  }

  onMouseMove() {
  }

  onMouseUp() {
  }

  onWheel() {
  }

  onWindowResize(width = this.canvas && this.canvas.clientWidth, height = this.canvas && this.canvas.clientHeight) {
    if (!this.canvas || !this.renderer || !this.camera) {
      return;
    }

    const targetWidth = Math.max(1, Math.floor(width || this.canvas.clientWidth));
    const targetHeight = Math.max(1, Math.floor(height || this.canvas.clientHeight));

    this.camera.aspect = targetWidth / targetHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(targetWidth, targetHeight, false);
  }

  // This methods will rotate scene in case OrbitControls wont fit everything

  // onMouseDown(event) {
  //   this.mouseDown = true;
  //   this.lastPosition = {
  //     x: event.clientX,
  //     y: event.clientY
  //   };
  // }
  //
  // onMouseMove(event) {
  //   if (!this.mouseDown) return;
  //
  //   const deltaX = event.clientX - this.lastPosition.x;
  //   const deltaY = event.clientY - this.lastPosition.y;
  //
  //   this.camera.rotation.y += deltaX * 0.01;
  //   this.camera.rotation.x += deltaY * 0.01;
  //
  //   this.lastPosition = {
  //     x: event.clientX,
  //     y: event.clientY
  //   };
  //
  //   this.renderer.render(this.scene, this.camera);
  // }
  //
  // onMouseUp() {
  //   this.mouseDown = false;
  // }
  //
  // onWheel(event) {
  //   const delta = event.deltaY * 0.001;
  //   this.camera.position.z += delta;
  //
  //   this.renderer.render(this.scene, this.camera);
  // }
  // onWindowResize() {
  //
  // }
}

export default SingleModelGLBViewer;
